import { StreamLanguage } from "@codemirror/language";
import { shell } from "@codemirror/legacy-modes/mode/shell";
import { EditorView, type Extension } from "@uiw/react-codemirror";
import { EDITOR_SURFACE } from "../../common/editor-theme";

// A curl command is a line of shell, so the mode is the shell's own — it is what tells a quoted body apart from the
// flags around it, and it is the one language here with no package of its own to import.
export const COMMAND_EXTENSIONS: Extension[] = [
  StreamLanguage.define(shell),
  // A pasted command is one long line, and a body scrolled off to the right is one nobody can read.
  EditorView.lineWrapping,
  ...EDITOR_SURFACE,
];

// A command is a handful of lines and the builder below is what names them, so there is nothing to number or fold.
export const COMMAND_SETUP = {
  lineNumbers: false,
  foldGutter: false,
  highlightActiveLine: false,
  highlightActiveLineGutter: false,
};
